export class Transport {

	static SAVE_CONSENT = 'saveConsent';
	static GET_TEXT = 'getText';

	constructor(config: Object, options: Object) {
		this.config = config;
		this.options = options;
	}

	async saveConsent() : Promise<Object> {
		return this.fetch(Transport.SAVE_CONSENT, {
			url: window.location.href,
			originId: this.config.originId,
			originatorId: this.config.originatorId,
		});
	}

	async getText() : Promise<string> {
		const response = await this.fetch(Transport.GET_TEXT, {}, this.options.textUrl);

		return response.text;
	}
	
	async fetch(action: string, data: Object, url: ?string = null) : Object {
		const response = await fetch(url || this.config.actionUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams(Object.assign({}, {
				action: action,
				id: this.config.id,
				sec: this.config.sec || '',
				sessid: BX.message('bitrix_sessid'),
			}, data)),
		});

		if (!response.ok) {
			throw new Error('Failed to execute ' + action);
		}

		const result = await response.json();

		if (result.error) {
			throw new Error(result.text);
		}

		return result;
	}
	
}